let targetOffsetTop = 0;
let offset = 0;
const button = document.querySelector<HTMLElement>('.faq-back-to-top');

if (button) {
  const updateButtonScroll = () => {
    button.style.display = window.scrollY > targetOffsetTop + offset ? '' : 'none';
  };

  const updateButtonResize = () => {
    const content = document.querySelector('.page-content');
    const reference = document.querySelector('[data-faq-reference]');
    const contentLeft = (content?.getBoundingClientRect().left ?? 0) + document.body.scrollLeft;

    if (content && reference) {
      const buttonOffset = contentLeft + parseFloat(getComputedStyle(content).width.replace('px', ''));
      button.style.right = `${(window.innerWidth - buttonOffset).toFixed(0)}px`;
      targetOffsetTop = reference.getBoundingClientRect().top;
      offset = parseInt(getComputedStyle(button).getPropertyValue('bottom'), 10);
      updateButtonScroll();
    }
  };

  const target = document.querySelector(button.getAttribute('data-faq-target')!); // eslint-disable-line @typescript-eslint/no-non-null-assertion

  button.addEventListener('click', () => {
    target?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  });

  window.addEventListener('scroll', updateButtonScroll);
  window.addEventListener('resize', updateButtonResize);

  updateButtonResize();
}
